import React, { FC } from 'react';
import * as TabStyles from './_tabSelector.module.scss';
import { TTabItems } from '~types/components/labelledDropdown';

type TabSelectorProps = {
    selectedTab: number;
    setSelectedTab: (tab: number) => void;
    tabs: TTabItems[];
    children?: React.ReactNode;
};

const TabSelector: FC<TabSelectorProps> = ({
    selectedTab,
    setSelectedTab,
    tabs,
    children,
}) => {
    const renderTabItems = () => {
        if (!tabs.length) return null;

        return tabs.map((tab) => (
            <div
                key={tab.value}
                className={`${TabStyles.tab} ${selectedTab === tab.value ? TabStyles.active : ''}`}
                onClick={() => setSelectedTab(tab.value)}
            >
                {tab.label}
            </div>
        ));
    };

    return (
        <div className={TabStyles.container}>
            <div className={TabStyles['overflow-container']}>
                <div className={TabStyles['tabs-container']}>
                    {renderTabItems()}
                </div>
            </div>

            <div className={TabStyles['content-container']}>
                {children}
            </div>
        </div>
    );
};

export default TabSelector;
